import React from 'react';
import PropTypes from 'prop-types';
import { Switch, Route } from 'react-router-dom';

import routeConfigs from './_routeConfigs';

import RouteGuard from './_routeGuard';

const renderRoutes = ({ routes, basePath, properties, shouldPageUpdated }) => (
  <Switch>
    {routes
      ? routes.map((route) => {
          return (
            <Route
              exact={route.exact}
              key={route.name}
              path={basePath ? basePath + route.path : route.path}
            >
              <RouteGuard
                Component={route.component}
                properties={properties}
                name={route.name}
                path={route.path}
                meta={route.meta}
                isMenuItem={route.isMenuItem}
                nodeOnly={route.nodeOnly}
                hasChildren={route.children && route.children.length > 0}
                shouldPageUpdated={shouldPageUpdated}
              />
            </Route>
          );
        })
      : undefined}
  </Switch>
);

export const SubRoutes = ({ name, ...properties }) => {
  const matchRoute = routeConfigs.find((route) => route.name === name);

  return matchRoute && matchRoute.children ? (
    renderRoutes({
      routes: matchRoute.children,
      basePath: matchRoute.path === '/' ? '' : matchRoute.path,
      properties,
    })
  ) : (
    <></>
  );
};

SubRoutes.propTypes = {
  name: PropTypes.string.isRequired,
};

export default ({ shouldPageUpdated }) => {
  return renderRoutes({ routes: routeConfigs, shouldPageUpdated });
};
